import gql from 'graphql-tag';







export const GET_AUDIT_LOGS = gql`
  query getWorkspaceAdminAuditLogsByOrganisationId($organisationId: String!, $filters: Filters) {
  getWorkspaceAdminAuditLogsByOrganisationId(organisationId: $organisationId, filters: $filters) {
    summary {
      totalCredits
      totalProjects
      totalFlex
      totalAdvanced
      totalAddonsCost {
        billingEntityCode
        cost
      }
    }
    auditLogs {
      projectId
      type
      subType
      usage
      credits
      addonsCost {
        billingEntityCode
        cost
      }
      isProjectSubmissionRecord
      createdBy {
        firstName
        lastName
      }
      createdAt
      showDetails
      invoiceId
      paymentStatus
      isProjectDeleted
      description {
        message
      }
    }
  }
}
`;

const getWorkspaceAdminAuditLogsByOrganisationId = (organisationId) => ({
  query: GET_AUDIT_LOGS,
  module: 'reporting',
  ignoreCache: true,
  buildVariables: (filters) => ({
    organisationId,
    filters
  }),
  isSilent: true
});

export default getWorkspaceAdminAuditLogsByOrganisationId;